import { EventSourceHandler } from '@sellsy/sse';

export default class SummaryGenerationFailedEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'staff.summary.generation.failed';
    }

    handle(event) {
        window.EventBus.emit('summary:failed', event.data);
    }
}
